export default __webpack_public_path__ + "static/media/gshopping-logo.3fb953a7.png";